import styled from 'styled-components';

export const BoxModal = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 15px;
  width: 32rem;
`;

export const TitleModal = styled.h6`
  font-weight: bold;
  color: #000;
  text-align: justify;
  margin-left: 0.5rem;
`;

export const ContainerTextModal = styled.div`
margin-top: 1rem;
margin-bottom: 1rem;
display: flex;
`;